import { render, staticRenderFns } from "./dentalAccountingV2.vue?vue&type=template&id=2112883d&scoped=true&"
import script from "./dentalAccountingV2.vue?vue&type=script&lang=js&"
export * from "./dentalAccountingV2.vue?vue&type=script&lang=js&"
import style0 from "./dentalAccountingV2.vue?vue&type=style&index=0&id=2112883d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2112883d",
  null
  
)

export default component.exports